/* everaw-reveal.js -- scroll reveals with no animation library.

   WHAT IT DOES
   The stylesheet draws every heading sparkle, card badge and section picture in
   its finished, visible state (assets/custom.css, "Scroll reveals"). This file
   sets data-ev-reveal="out" on an element that waits below the screen and "in"
   when its trigger scrolls past its line, and a CSS transition does the motion.
   It asks for no frames. If it never runs, nothing is hidden.

   A RULE
     sel       the element that moves
     trigger   the ancestor whose top edge is watched; the element itself if none
     line      how far down the screen that edge must come, in percent
     once      play one time, never reverse
     stagger   seconds between elements that arrive in the same callback,
               capped at staggerMax

   WHY THE FIRST SCAN WAITS FOR LOAD
   assets/custom.css arrives late and decides where everything sits, so a
   position read before the load event is not the final one.

   WHY AN ELEMENT ON SCREEN IS LEFT ALONE
   On its first callback an element that is on screen, or above it, keeps the
   finished state. Marking it "out" then would make it vanish in front of the
   shopper. Only an element wholly below the screen is marked "out".

   WHY A SIDEWAYS RAIL IS ONE TRIGGER
   A card off to the side of a rail is not on screen, so on its own trigger it
   would stay at size zero until someone swiped to it. An element inside a
   container that scrolls sideways takes that container as its trigger, and the
   whole row reveals when the rail arrives. The rail is found by geometry (the
   nearest ancestor with overflow-x auto or scroll that is wider inside than
   outside), not by class name, so a new rail needs no entry here.

   WHY THE CART DRAWER IS SKIPPED
   The drawer opens on a tap, not on a scroll, so its cards keep the finished
   state and take no place in the badge stagger.

   THE ABOUT PAGE HOLD
   sections/about-img_text.liquid holds its section in place for 500 px of
   scroll with position: sticky, and a CSS view timeline fades the first
   picture into the second over that distance. A browser without view
   timelines gets the same curve from the first block below: it marks the
   wrapper data-about-pin="script" and moves --about-p from 0 to 1 with the
   scroll position. The scroll listener exists only while the wrapper is on
   screen. It is the one place where this file asks for a frame: one after a
   scroll, none at rest. It also runs under reduced motion: the hold is layout,
   and the fade follows the finger, it does not play by itself. */

(function () {
  var pin = document.querySelector('.about-pin');
  if (pin && 'IntersectionObserver' in window && !(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))) {
    pin.setAttribute('data-about-pin', 'script');
    var queued = false;
    var paint = function () { queued = false; pin.style.setProperty('--about-p', Math.min(1, Math.max(0, -pin.getBoundingClientRect().top / 500))); };
    var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(paint); } };
    new IntersectionObserver(function (es) {
      if (es[es.length - 1].isIntersecting) { addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
      else removeEventListener('scroll', onScroll);
    }).observe(pin);
  }

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var RULES = [
    { sel: '.text-left img.head-line', line: 85 },
    { sel: 'img.span_img', line: 85 },
    { sel: '.gradient-img-text_media', trigger: '.gradient-img-text', line: 80 },
    { sel: '.ct-newsletter_media', trigger: '.ct-newsletter', line: 80 },
    { sel: '.gradient-img-text-2_media img.gradient_media', trigger: '.gradient-img-text-2', line: 80 },
    { sel: '.pro_info-main .pro_info_badge', trigger: '.pro_info-main', line: 90, once: true, stagger: 0.2, staggerMax: 0.6 }
  ];
  var items = new Map();   // trigger element -> the items it reveals
  var observers = {};      // one observer per line

  function onEntries(entries, io) {
    var n = 0;
    entries.forEach(function (e) {
      var past = e.isIntersecting || e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0);
      (items.get(e.target) || []).forEach(function (it) {
        if (it.io !== io) return;   // a rail can be the trigger of two rules with different lines
        if (!it.armed) {
          it.armed = true;
          if (past || e.boundingClientRect.top < window.innerHeight) { it.done = it.rule.once; return; }
          it.el.setAttribute('data-ev-reveal', 'out');
          return;
        }
        if (it.done) return;
        if (past) {
          if (it.rule.stagger) it.el.style.setProperty('--ev-delay', Math.min(n++ * it.rule.stagger, it.rule.staggerMax) + 's');
          it.el.setAttribute('data-ev-reveal', 'in');
          it.done = it.rule.once;
        } else it.el.setAttribute('data-ev-reveal', 'out');
      });
    });
  }

  /* The nearest ancestor that scrolls sideways and has something to scroll. */
  function rail(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var o = getComputedStyle(p).overflowX;
      if ((o === 'auto' || o === 'scroll') && p.scrollWidth > p.clientWidth) return p;
    }
    return null;
  }

  function scan(root) {
    RULES.forEach(function (rule) {
      root.querySelectorAll(rule.sel).forEach(function (el) {
        if (el.closest('cart-drawer')) return;
        if (el.hasAttribute('data-ev-seen')) return;
        el.setAttribute('data-ev-seen', '');
        var t = rule.trigger ? el.closest(rule.trigger) : el;
        if (!t) return;
        t = rail(t) || t;
        var io = observers[rule.line] || (observers[rule.line] = new IntersectionObserver(onEntries, { rootMargin: '0px 0px -' + (100 - rule.line) + '% 0px' }));
        if (!items.has(t)) items.set(t, []);
        items.get(t).push({ el: el, rule: rule, io: io, armed: false, done: false });
        io.observe(t);
      });
    });
  }

  if (document.readyState === 'complete') scan(document);
  else window.addEventListener('load', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
